import * as exMount from './mount';
import type { IManagerConfig, IManagerApi } from './types';

// ----------------------------------------------------------------------------

declare global {
    interface HTMLSelectElement {
        select(config?: IManagerConfig): IManagerApi | undefined;
    }
}

// ----------------------------------------------------------------------------

HTMLSelectElement.prototype.select = function (config?: IManagerConfig): IManagerApi | undefined {
    return exMount.mount(this, config);
};
